import api from './api';

export const sharePointService = {
    listFiles: async (folder, element) =>
        (await api.get('/core/sharepoint/files/', {params: {folder, element}})).data, 

    uploadFile: async (file, folder, element) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('folder', folder);
        formData.append('element', element);
        return (await api.post('/core/sharepoint/upload/', formData)).data;
    },

    downloadFile: async (folder, filename, element) => {
        const response = await api.get('/core/sharepoint/download/', {
            params: {folder, filename, element}, responseType: 'blob',
        });
        const url = URL.createObjectURL(response.data);
        const a = document.createElement('a');
        a.href = url; a.download = filename; a.click();
        URL.revokeObjectURL(url);
    },

    createFolder: async (folderPath, element) =>
    (await api.post('/core/sharepoint/create-folder/', {folder: folderPath, element})).data,
};